import {
  BooleanValidation,
  ConfigOptionValidation,
  StringValidation,
} from '../../../utils/component-validations';
import { on } from '@ember/modifier';
import { or, reads } from 'macro-decorators';
import { tracked } from '@glimmer/tracking';
import SpdsAutofocus from '../../../modifiers/spds-autofocus';
import Super from './base.gjs';
import styles from './input.module.scss';

const SUPPORTED_TYPES = ['checkbox', 'radio', 'text'];

export default class SpdsCoreInput extends Super {
  baseArguments = [
    new BooleanValidation({
      optional: ['checked', 'disabled', 'error', 'indeterminate', 'noBorder', 'required'],
    }),
    new ConfigOptionValidation({
      required: [
        {
          name: 'type',
          options: SUPPORTED_TYPES,
        },
      ],
    }),
    new StringValidation({
      optional: ['ariaLabel', 'inputClasses', 'name', 'placeholder', 'value'],
    }),
  ];
  baseClass = 'spds-input';
  classesToMapToArgs = ['error', 'inputClasses', 'noBorder'];
  defaultComponentName = 'Spds::Core::Input';
  styles = styles;

  @tracked baseElement;

  @or('args.groupName', 'args.name') name;
  @reads('args.value') value;

  get arguments() {
    let { additionalArguments = [] } = this.args;

    return [...this.baseArguments, ...additionalArguments];
  }

  get componentName() {
    let { component = this.defaultComponentName } = this.args;

    return `${component} - instance #${this.id} - `;
  }

  onClick = evt => {
    let { checked, id, name: groupName } = evt.target;
    let { value } = this;

    this.args.onClick?.({ checked, event: evt, groupName, id, value });
  };

  onInput = evt => {
    this.args.onInput?.(evt);
  };

  <template>
    <input
      aria-label={{@ariaLabel}}
      checked={{@checked}}
      class={{this.classes}}
      data-test-spds-input={{this.id}}
      disabled={{@disabled}}
      id={{this.id}}
      indeterminate={{@indeterminate}}
      maxlength={{@maxLength}}
      name={{this.name}}
      placeholder={{@placeholder}}
      required={{@required}}
      type={{@type}}
      value={{this.value}}
      {{on "click" this.onClick}}
      {{on "input" this.onInput}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      {{SpdsAutofocus @autofocus}}
      ...attributes
    />
  </template>
}
